import { NextSeo } from 'next-seo'
import SEO from '~~/next-seo.config'
import { style } from '~~/src/pages/404'

import NavBar from '~~/src/components/Main/NavBar'
import SelectChain from '~~/src/components/Minting_components/SelectChain'
import { Toaster } from 'react-hot-toast'

function Chain() {

  return (
    <div className={style.wrapper}>
      <NextSeo
        title={`Deepcity.io | Unlock Your NFT Potential: Explore Ethereum and Polygon Networks for Minting Perfection`}
        description={`Discover the Ideal Blockchain Network for NFT Minting: Select the perfect blockchain that caters to your specific needs. Explore Ethereum and Polygon network options today.`}
        {...SEO}
      />
      <Toaster position='top-center' />
      <NavBar />
      <SelectChain />
    </div>
  )
}

export default Chain